import { DRAWER_MENU } from "../types";

export interface IDrawerMenu {
  menu: any;
  originalMenu: any;
  screenFirstPoint: number | null;
  screenPermissions: any;
}

const initialState: IDrawerMenu = {
  menu: [],
  originalMenu: [],
  screenFirstPoint: null,
  screenPermissions:[]
};

export const drawerMenuReducer = (
  state: IDrawerMenu = initialState,
  action: any,
): IDrawerMenu => {
  switch (action.type) {
    case DRAWER_MENU.DRAWER_MENU_SET_SELECTED:
      return {
        ...state,
        menu: action.payload.menu,
        originalMenu: action.payload.originalMenu,
        screenFirstPoint: action.payload.screenFirstPoint,
        screenPermissions: action.payload.screenPermissions,
      };

    case DRAWER_MENU.DRAWER_MENU_CLEAR_SELECTED:
      return {
        ...state,
        menu: [],
        originalMenu: [],
        screenFirstPoint: null,
        screenPermissions: [],
      };

    default:
      return state;
  }
};
